/**
 * @generated SignedSource<<e4c8941fee4c1a52d9707b64406a739d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUProductEditScreenProduct_PLUProduct$data = {
  readonly active: boolean;
  readonly category: {
    readonly id: string;
  };
  readonly eanCode: string | null;
  readonly eanType: string;
  readonly id: string;
  readonly image: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  } | null;
  readonly pluCode: string | null;
  readonly title: string;
  readonly " $fragmentType": "PLUProductEditScreenProduct_PLUProduct";
};
export type PLUProductEditScreenProduct_PLUProduct$key = {
  readonly " $data"?: PLUProductEditScreenProduct_PLUProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"PLUProductEditScreenProduct_PLUProduct">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PLUProductEditScreenProduct_PLUProduct",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eanCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eanType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pluCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PLUCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PLUProduct",
  "abstractKey": null
};
})();

(node as any).hash = "d8ae5defb61de369c03e94c8b19aeb05";

export default node;
